import { styled } from '@mui/material/styles';
import { StyledTag } from '../styled-components/tag';

export const Wrapper = styled(StyledTag)``;
